import React, { MouseEvent as ReactMouseEvent, ReactNode } from 'react';
import { useCollectionContext } from '@wix/bex-core/react';
import { TextButton } from '@wix/design-system';
import { Add } from '@wix/wix-ui-icons-common';

export interface NewItemButtonProps {
  /**
   * Callback for "New Item" button click. When not passed "New Item" will not be rendered.
   * @external
   */
  onAddNewClick?: (e: ReactMouseEvent<HTMLButtonElement, MouseEvent>) => void;
  /**
   * Text for "New Item" button
   * @external
   */
  addNewText?: ReactNode;
}

export function NewItemButton(props: NewItemButtonProps) {
  const state = useCollectionContext();
  const { translate: t } = state;
  const { onAddNewClick, addNewText } = props;

  return (
    <TextButton
      onClick={onAddNewClick}
      prefixIcon={<Add />}
      dataHook="empty-state-new-item-button"
    >
      {addNewText ?? t('cairo.emptyState.additem.cta')}
    </TextButton>
  );
}
